import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import styles from "../../styles/customTable/CustomTable.module.css"
const FilterDialogMobile = ({
  showMobileFilters,
  setShowMobileFilters,
  filters,
  getFilterType,
  applyFilters,
  resetFilters,
  validOptions,
}) => {
  return (
    <Dialog
      showHeader={false}
      visible={showMobileFilters}
      style={{ width: "95vw" }}
    >
      <div className={styles.filterMobileModalHeader}>
        <label className={styles.filterMobileModalTitle}>Filters</label>
        <Button
          onClick={() => {
            resetFilters()
            setShowMobileFilters(false)
          }}
          className={styles.rounded_btn}
          icon="pi pi-times"
        />
      </div>
      <hr className={`line mb-3`} />
      {/* eslint-disable-next-line array-callback-return */}
      {filters?.map((filter) => {
        if (validOptions(filter)) {
          return (
            <div className={styles.headerItem} key={filter.label}>
              {filter.label && (
                <label className={styles.headerLabel}>{filter.label}</label>
              )}
              {getFilterType(filter)}
            </div>
          )
        }
      })}
      <div className={styles.filterMobileModalFooter}>
        <Button
          label="Reset"
          icon="pi pi-times"
          iconPos="left"
          className={`${styles.mobileFooterButton} ${styles.resetButton}`}
          onClick={() => {
            resetFilters()
          }}
        />
        <Button
          label="Cancel"
          className={`${styles.mobileFooterButton} ${styles.cancelButton}`}
          onClick={() => {
            setShowMobileFilters(false)
          }}
        />
        <Button
          label="Apply"
          className={`${styles.mobileFooterButton} ${styles.applyButton}`}
          onClick={() => {
            applyFilters()
            setShowMobileFilters(false)
          }}
        />
      </div>
    </Dialog>
  )
}
export default FilterDialogMobile
